export const DEFAULT_REDIRECT_URL = '/dashboard?authSuccess=true';
